import { render, staticRenderFns } from "./SithMesTpmAxisDataTadList.vue?vue&type=template&id=539e38f6&"
import script from "./SithMesTpmAxisDataTadList.vue?vue&type=script&lang=js&"
export * from "./SithMesTpmAxisDataTadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports